<template>
	<div class="trainers">
		<h2>Тренажеры</h2>
		<back></back>
		<ul class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match uk-flex-center uk-grid-small" uk-grid>
			<li v-for="trainer in trainers" :key="trainer.id">
				<router-link :to="'/trainer/' + trainer.component">
					<div class="maincontent__item maincontent__item--train">
						<div class="maincontent__ico">
							<img v-if="trainer.icon" :src="trainer.icon.path" :alt="trainer.title">
						</div>
						<p>{{ trainer.title }}</p>
					</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
  export default {
    name: "trainers",
	  computed: {
			...mapGetters({
				trainers: 'train/trainers'
			})
	  }
  }
</script>